import http from "./config/NetworkClient";

export default class BookingApi {
  static async getPreAppointmentData(
    studio_location_id,
    instructor_id,
    appointment_keys = ""
  ) {
    let url = `/client/booking/pre-appointment-data?instructor_id=${instructor_id}`;
    if (studio_location_id) {
      url += `&studio_location=${studio_location_id}`;
    }
    if (appointment_keys) {
      url += appointment_keys;
    }

    return await http.get(url);
  }

  static async getPreAppointmentDataDuration(studio_location_id, instructor_id, appointment_keys) {
    const response = await http.get(
      `/client/booking/pre-appointment-data/duration?instructor_id=${instructor_id}&studio_location=${studio_location_id}${appointment_keys}`
    );
    return response;
  }

  static async getInstructorLocation(instructor_id) {
    const response = await http.get(
      `/client/booking/instructor/${instructor_id}/locations`
    );
    return response;
  }

  static async getAppointmentTypes(instructor_id, locationId, payload) {
    const response = await http.get(
      `/client/booking/instructor/${instructor_id}/location/${locationId}/appointment-types`,
      payload
    );
    return response;
  }

  static async getInstructorAvailabiltyData(
    instructor_id,
    locationId,
    appointment_type_id,
    payload
  ) {
    const response = await http.get(
      `/client/booking/available-times?instructor_id=${instructor_id}&studio_location_id=${locationId}&appointment_type_id=${appointment_type_id}`,
      payload
    );
    return response;
  }

  // static async getInstructorAvailabiltyData(
  //   instructor_id,
  //   studio_location,
  //   payload
  // ) {
  //   // console.log(payload);
  //   const response = await http.get(
  //     `/api/v3/instructor-availability/${instructor_id}/studio_location/${studio_location}`,
  //     payload
  //   );
  //   return response;
  // }

  static async confirmBooking(payload) {
    const submission_id = await window.localStorage.getItem("submission_id");
    if (submission_id) {
      payload["submission_id"] = submission_id;
    }
    const response = await http.post(
      "/client/booking/confirm-appointment",
      payload
    );
    return response;
  }

  static async getAnotherPatients(payload) {
    const response = await http.get("/client/public/user_relative?sort=id:asc");
    return response;
  }

  static async addAnotherPatient(payload) {
    const response = await http.post("/client/public/user_relative", payload);
    return response;
  }

  static async updatePatient(id, payload) {
    const response = await http.put(
      `/client/public/user_relative/${id}`,
      payload
    );
    return response;
  }

  // static async getAssignFormData(payload) {
  //   const response = await http.post("/api/v3/assign-form-submission", payload);
  //   return response;
  // }

  static async assignManualFormData(payload) {
    //this should be delete
    const response = await http.post(
      "/api/v3/assign-manual-submission",
      payload
    );
    return response;
  }

  static async cancelAppointment(id) {
    const response = await http.put(
      `/client/booking/appointment/${id}/cancel/`
    );
    return response;
  }

  static async getPreConfirmingAppointmentData(
    appointment_type_id,
    instructor_id
  ) {
    const response = await http.get(
      `/client/booking/pre-confirm-appointment-data?appointment_type_id=${appointment_type_id}&instructor_id=${instructor_id}`
    );
    return response;
  }

  static async getSupportInfo() {
    const response = await http.get(`/client/booking/support-info/`);
    return response;
  }

  static async getCancellationMessage(id) {
    const response = await http.get(
      `/client/booking/appointment/${id}/cancellation-message/`
    );
    return response;
  }

  static async getSelectDateTimeData(id) {
    const response = await http.get(`/api/v3/waitlist/user_booking_info/${id}`);
    return response;
  }

  static async rematchAppointment(id, studio_location_id) {
    const response = await http.put(
      `/client/booking/appointment/${id}/rematch?studio_location_id=${studio_location_id}`
    );
    return response;
  }
}
